import { HIDE_TOAST, SHOW_TOAST } from "../actions/types";

const initialToast = {
  visible: false,
  message: "",
  type: "",
};

//Hide and Show toast messages
export const toastReducer = (state = initialToast, { type, payload }) => {
  switch (type) {
    case SHOW_TOAST:
      return {
        visible: true,
        message: payload.message,
        type: payload.type,
      };
    case HIDE_TOAST:
      return {
        visible: false,
        message: "",
        type: "",
      };
    default:
      return state;
  }
};
